import { TEqualityFunction } from '@core/js/store/types';

import { REDUCER_NAMES } from '@interlayer/js/app/store/constants';
import { TRegistrationState } from '@interlayer/js/app/store/reducers/Registration/types';
import { TRegistrationSelector } from '@interlayer/js/app/store/types';

import { useCustomSelector } from './useCustomSelector';

export const useRegistrationSelector = <TSelected = TRegistrationState>(
    selector?: TRegistrationSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => useCustomSelector<TSelected, typeof REDUCER_NAMES.registration>(REDUCER_NAMES.registration, selector, equalityFn);
